import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Dropdown } from 'react-bootstrap';
import { Checkbox } from 'react-icheck';
import CustomDropdownMenu from './CustomDropdownMenu';
import { withTranslation, Trans } from 'react-i18next';

class GradesDropdown extends Component {
	constructor(props) {
		super(props);

		this.handleGradeChange = this.handleGradeChange.bind(this);
	}

	handleGradeChange(grade, checked) {
		let selectedIds = this.props.selectedGrades.map(x => x.id);
		if (checked) {
			selectedIds.push(grade.id);
		} else {
			selectedIds = selectedIds.filter(x => x !== grade.id);
		}
		this.props.onSelectGrades([...new Set(selectedIds)]);
	}

	render() {
		const { id = 'gradesDropdown', grades, selectedGrades, t } = this.props;

		let multipleSelectedGradesDisplayName = null;
		if (selectedGrades.length > 1) {
			const firstSelectedGrade = selectedGrades[0].name, otherCount = selectedGrades.length - 1;
			multipleSelectedGradesDisplayName = <Trans i18nKey='FO_TimetableSearch_Grades_Multiple'>
				{{ firstSelectedGrade }}<span style={{ fontSize: 'smaller' }}> and {{ otherCount }} other</span>
			</Trans>;
		}
		const selectedGradesDisplayName = selectedGrades.length === 0 || selectedGrades.length === grades.length ? t('FO_TimetableSearch_Grades_All') :
			selectedGrades.length === 1 ? selectedGrades[0].name : multipleSelectedGradesDisplayName;

		return <Dropdown id={id}>
			<Button bsRole='toggle' className='btn btn-primary btn-block-xxs'>{selectedGradesDisplayName} <span className='caret'/></Button>
			<CustomDropdownMenu bsRole='menu' style={{ minWidth: '300px' }}>
				{grades.map(grade => <li key={grade.id}><Checkbox
					label={grade.name} checkboxClass='icheckbox_minimal-grey' increaseArea='20%'
					checked={selectedGrades.some(x => x.id === grade.id)}
					onChange={e => this.handleGradeChange(grade, e.target.checked)}
				/></li>)}
			</CustomDropdownMenu>
		</Dropdown>;
	}
}

GradesDropdown.propTypes = {
	grades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	selectedGrades: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string
	})),
	onSelectGrades: PropTypes.func.isRequired
};

export default withTranslation()(GradesDropdown);